module.exports = __webpack_public_path__ + "static/media/microphone.99ce6ab3.svg";